import type { GmAppConfig } from '@/app.config';
import { inject } from 'vue';

export function useAppConfig() {
  const appConfig = inject<GmAppConfig>('appConfig');
  if (!appConfig) throw new Error('App config is missing');
  return appConfig;
};
